module.exports = __webpack_public_path__ + "img/500-d8d81e.png";